import React from 'react';

const ChefHatGold = props => {
  return (
   <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 27H24" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square"/>
    <path d="M16 27V22" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square"/>
    <path d="M9.3 6.59999C8.8 6.49999 8.3 6.39999 7.8 6.39999C4.1 6.49999 1 9.49999 1 13.3C1 17.1 4.2 20 8 20V31H24V20C27.8 20 31 17 31 13.3C31 9.59999 27.9 6.49999 24.2 6.49999C23.7 6.49999 23.2 6.59999 22.7 6.69999" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10"/>
    <path d="M9.80001 10.5C9.40001 9.7 9.20001 8.8 9.20001 7.8C9.20001 4.1 12.2 1 16 1C19.8 1 22.8 4.1 22.8 7.8C22.8 8.8 22.6 9.7 22.2 10.5" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square"/>
  </svg>
  );
};

export default ChefHatGold;



// WEBPACK FOOTER //
// ./src/svg/ChefHatGold.js